import { z } from 'zod';

/**
 * The compare tool's search params, shared by the route that validates them
 * and the page that reads them back — one schema, so the two cannot drift.
 *
 * `mode` is the tab to open on; `left` and `right` name saved pricelists to
 * fill the slots with. A pricelist's Compare action lands here with that
 * pricelist already in the first slot; the Utilities tile for pricelists
 * opens straight on that tab.
 */
export const compareCsvsSearchSchema = z.object({
  mode: z.enum(['files', 'pricelists']).optional(),
  left: z.uuid().optional(),
  right: z.uuid().optional(),
});

export type CompareCsvsSearch = z.infer<typeof compareCsvsSearchSchema>;
